import { SasCheckboxFieldTypeComponent } from './sas-checkbox-field-type/sas-checkbox-field-type.component';
import { SasDatepickerFieldTypeComponent } from './sas-datepicker-field-type/sas-datepicker-field-type.component';
import { SasDatepickerRangeFieldTypeComponent } from './sas-datepicker-range-field-type/sas-datepicker-range-field-type.component';
import { SasGazetteerStreetFieldTypeComponent } from './sas-gazetteer-street-field-type/sas-gazetteer-street-field-type.component';
import { SasGazetteerUprnFieldTypeComponent } from './sas-gazetteer-uprn-field-type/sas-gazetteer-uprn-field-type.component';
import { SasInputEmailFieldTypeComponent } from './sas-input-email-field-type/sas-input-email-field-type.component';
import { SasInputPasswordFieldTypeComponent } from './sas-input-password-field-type/sas-input-password-field-type.component';
import { SasInputTextFieldTypeComponent } from './sas-input-text-field-type/sas-input-text-field-type.component';
import { SasMultiselectFieldTypeComponent } from './sas-multiselect-field-type/sas-multiselect-field-type.component';
import { SasRadiobuttonFieldTypeComponent } from './sas-radiobutton-field-type/sas-radiobutton-field-type.component';
import { SasRepeatSectionComponent } from './sas-repeat-section/sas-repeat-section.component';
import { SasSelectFieldTypeComponent } from './sas-select-field-type/sas-select-field-type.component';
import { SasSelectMultipleFieldTypeComponent } from './sas-select-multiple-field-type/sas-select-multiple-field-type.component';
import { SasStreetFieldTypeComponent } from './sas-street-field-type/sas-street-field-type.component';
import { SasSubFormComponent } from './sas-sub-form/sas-sub-form.component';
import { SasSwitchFieldTypeComponent } from './sas-switch-field-type/sas-switch-field-type.component';
import { SasTextareaFieldTypeComponent } from './sas-textarea-field-type/sas-textarea-field-type.component';
import { SasTimepickerFieldTypeComponent } from './sas-timepicker-field-type/sas-timepicker-field-type.component';
//import { SasSelectSectionComponent } from './sas-select-section/sas-select-section.component';

export const SasDynamicFormsTypes = [
    {
        name: 'sasInput',
        component: SasInputTextFieldTypeComponent,
    },
    {
        name: 'sasInputMail',
        component: SasInputEmailFieldTypeComponent,
    },
    {
        name: 'sasInputPassword',
        component: SasInputPasswordFieldTypeComponent,
    },
    {
        name: 'sasTextarea',
        component: SasTextareaFieldTypeComponent,
    },
    {
        name: 'sasCheckbox',
        component: SasCheckboxFieldTypeComponent
    },
    {
        name: 'sasSelect',
        component: SasSelectFieldTypeComponent
    },
    {
        name: 'sasRadiobutton',
        component: SasRadiobuttonFieldTypeComponent,
    },
    {
        name: 'sasGazetteerStreet',
        component: SasGazetteerStreetFieldTypeComponent,
    },
    {
        name: 'sasDateRangePicker',
        component: SasDatepickerRangeFieldTypeComponent,
    },
    {
        name: 'sasDatepicker',
        component: SasDatepickerFieldTypeComponent,
    },
    {
        name: 'sasMultiselect',
        component: SasMultiselectFieldTypeComponent,
    },
    {
        name: 'multiselect',
        component: SasSelectMultipleFieldTypeComponent
    },
    {
        name: 'sasSwitch',
        component: SasSwitchFieldTypeComponent
    },
    {
        name: 'selectSection',
        component: SasSubFormComponent
    },
    {
        name: 'repeatSection',
        component: SasRepeatSectionComponent
    },
    {
        name: 'sasStreet',
        component: SasStreetFieldTypeComponent
    },
    {
        name: 'sasGazetteerUprn',
        component: SasGazetteerUprnFieldTypeComponent
    },
    {
        name: 'sasTimepicker',
        component: SasTimepickerFieldTypeComponent
    }
    //{
    //    name: 'sasSubForm',
    //    component: SasSubFormComponent
    //}
];
